<template>
<div>
  <div
    ref="button"
    class="qrcode-button"
    @click="getQrcode"
    data-toggle="modal" data-target=".bs-qrcode-modal">
  </div>
  <!-- 二维码 -->
  <div class="modal fade bs-qrcode-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body text-center">
          <img v-if="qrcodeUrl" :src="qrcodeUrl" width="200" height="200">
          <qrcode v-else :value="qrcodePicSrc" :options="{ size: 300, level: 'H'}" tag="img"></qrcode>
          <p class="qrcode-footer" v-if="!qrcodeDesc">{{ $t('imagewall.sweepAndShareTips') }}</p>
          <p class="qrcode-logo">{{ qrcodeDesc ? qrcodeDesc : $t('imagewall.product') }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
 
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'

export default {
  data: () => ({
    isProcessing: false,
    qrcodePicSrc: '',
  }),
  props: {
    qrcodeUrl: String,
    qrcodeDesc: String
  },
  components: {
    qrcode: VueQrcode
  },
  mounted() {
  },
  methods: {
    getQrcode(){
      //console.log('qrcodeDesc', this.qrcodeDesc)
      // Vue.axios.post('/api/qrcode', {
      //   activityId: this.$route.params.id,
      //   title: this.title
      // }).then(({status, data})=>{
      //   if(status === 200) {
      //     //console.log(data)
      //     if(data && data.result) {
      //       this.qrcodePicSrc = data.result.url
      //     }
      //   }
      // })
      console.log(this.qrcodeUrl)
      if(!this.qrcodeUrl){
        var activityId = this.$route.params.id
        console.log('host', window.location.host)
        var host = window.location.host.replace("yun.cam-fi.com", "yuncdn.cam-fi.com");
        this.qrcodePicSrc = `http://${host}/activity/${activityId}`
      }
    },
  }
}
</script>
